import { render, staticRenderFns } from "./DivisionGroup.vue?vue&type=template&id=ca758e74&scoped=true&"
import script from "./DivisionGroup.vue?vue&type=script&lang=js&"
export * from "./DivisionGroup.vue?vue&type=script&lang=js&"
import style0 from "./DivisionGroup.vue?vue&type=style&index=0&id=ca758e74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca758e74",
  null
  
)

export default component.exports